import React, { useContext } from 'react'
import { Navigate, Outlet } from 'react-router-dom'
import { Box } from '@mui/material'
import { AuthContext } from './components/Authentication/AuthContext'
import LottieLoader from './components/shared/atom/LottieLoader'

interface ProtectedRouteProps {
  allowedGroups: string[]
  allowedRoles: any[]
}

const ProtectedRoute: React.FC<ProtectedRouteProps> = ({ allowedGroups, allowedRoles }) => {
  const context = useContext(AuthContext)
  const { groups, loading, removalRole } = context

  if (Boolean(loading)) {
    return (
      <Box
        sx={{
          width: '100%',
          height: '100vh',
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
        }}>
        <LottieLoader />
      </Box>
    )
  }


  if (!groups.length) {
    console.log('Navigating to login due to absense of User Group')
    return <Navigate to="/login" replace />
  }


  const hasAccess = groups.some((group) => allowedGroups.includes(group)) && allowedRoles.includes(removalRole) 

  return hasAccess ? <Outlet /> : <Navigate to="/unauthorized" replace />
}

export default ProtectedRoute
